export type BrowserName =
  | "chrome"
  | "edge"
  | "opera"
  | "firefox"
  | "safari"
  | "unknown";

export const getBrowser = () => {
  const ua = navigator.userAgent;

  /*
   * Chromium Edge and Opera both carry "Chrome/" in their user agent, so they
   * have to be ruled out before Chrome is claimed. Mistaking Edge for Chrome is
   * the exact failure this detection exists to prevent — see CSRTB-1034 — so
   * the order of these checks is load-bearing.
   */
  const isEdge = /Edg\//i.test(ua);
  const isOpera = /OPR\//i.test(ua);
  const isChrome = /Chrome\//i.test(ua) && !isEdge && !isOpera;
  const isFirefox = /Firefox\//i.test(ua);
  // Safari identifies by omission: every Chromium user agent also says "Safari/".
  const isSafari = /Safari\//i.test(ua) && !/Chrome\/|Chromium\//i.test(ua);

  let name: BrowserName = "unknown";
  if (isEdge) name = "edge";
  else if (isOpera) name = "opera";
  else if (isChrome) name = "chrome";
  else if (isFirefox) name = "firefox";
  else if (isSafari) name = "safari";

  return { name, isChrome, isEdge, isOpera, isFirefox, isSafari };
};
